import React from "react";
import { Eye, Loader2 } from "lucide-react";

export const FullScreen = ({ text }) => (
  <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center gap-4" data-testid="app-loading">
    <span className="w-12 h-12 rounded-md bg-primary text-white flex items-center justify-center">
      <Eye className="w-6 h-6" strokeWidth={2} />
    </span>
    <div className="flex items-center gap-2 text-slate-500">
      <Loader2 className="w-5 h-5 animate-spin" /> {text}
    </div>
  </div>
);
